// Stable per-visitor identifier used on auth lifecycle requests
// (x-visitor-token header). It intentionally persists across logout/login
// cycles on the same browser profile.

const VISITOR_TOKEN_KEY = "merchantVisitorToken";

export const getVisitorToken = () => {
  try {
    const existing = localStorage.getItem(VISITOR_TOKEN_KEY);
    if (existing) return existing;

    const generated = `visitor-merchant-${Date.now()}-${Math.random()
      .toString(36)
      .slice(2, 10)}`;

    localStorage.setItem(VISITOR_TOKEN_KEY, generated);
    return generated;
  } catch {
    return null;
  }
};
